import { render, staticRenderFns } from "./AddProductTransferStok.vue?vue&type=template&id=585fbc10"
import script from "./AddProductTransferStok.vue?vue&type=script&lang=js"
export * from "./AddProductTransferStok.vue?vue&type=script&lang=js"
import style0 from "./AddProductTransferStok.vue?vue&type=style&index=0&id=585fbc10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports